import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as _ from 'lodash';
import { STORAGE, PETICIONES, LANG_OPTIONS } from 'src/app/core/utils/constants';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { UserprofileService } from 'src/app/core/repositories/userprofile.service';
import { Userprofile } from 'src/app/core/entities/userprofile.model';
import { CarpTipusCarpeta } from 'src/app/core/entities/carptipuscarpeta.model';
import { CarpAvisosTer } from 'src/app/core/entities/carpavisoster.model';
import { TokenValid } from 'src/app/core/auth/tokenvalid.model';
import { Utils } from 'src/app/core/utils/utils';
import { TranslateService } from '@ngx-translate/core';


@Injectable()
export class DialogsPerfilService {


    carpTipusCarpeta: CarpTipusCarpeta[] = new Array<CarpTipusCarpeta>();

    carpAvisosTer: CarpAvisosTer[] = new Array<CarpAvisosTer>();
    carpAvisosTerSave: CarpAvisosTer[] = new Array<CarpAvisosTer>();

    userProfile : Userprofile = new Userprofile();
    originalUserProfile: Userprofile = new Userprofile();

    titulo: string = "";
    valores: string = "";
    dboid: string = "";
    validToken: TokenValid = new TokenValid();
    langOption: any[] = LANG_OPTIONS;

    constructor(private repositoryService: RepositoryService,
                private userprofileService: UserprofileService,
                private translateService: TranslateService) { }

    init(datos: any): Observable<any> {

        this.langOption[0].label = this.translateService.instant('catalan');
        this.langOption[1].label = this.translateService.instant('espanol');

        this.dboid = datos.dboid;
        let stringToken = localStorage.getItem(STORAGE.VALID_TOKEN) ?? "";
        this.validToken = JSON.parse(stringToken);
        return forkJoin([this.repositoryService.doGet(PETICIONES.carpTipusCarpeta.findAll),
                        this.repositoryService.findByCode(PETICIONES.userprofile.findByIdentifier, this.validToken.identifier)])
            .pipe(map(dataGroup => {

                this.carpTipusCarpeta = dataGroup[0];
                this.userProfile = dataGroup[1];

                if(this.userProfile == null){
                    this.userProfile = new Userprofile();
                }

                this.originalUserProfile = _.cloneDeep(this.userProfile);

                for (let i = 0; i < this.carpTipusCarpeta.length; i++) {
                    if (this.carpTipusCarpeta[i].codi === datos.tipocarpeta) {
                        this.titulo = this.carpTipusCarpeta[i].descripcio;
                    }
                }

            }),catchError((error: any) => {
                console.log(error);
                throw error;
            }));
    }

    /**
    * @description
    * Guardar el Perfil con los cambios producidos por el usuario
    */
    guardar(): Observable<any> {
        let userNew = new Userprofile();
        if(this.userProfile.identifier == null){
            userNew.identifier = this.validToken.identifier;
            userNew.lang = this.userProfile.lang;
        }else{
            userNew = _.cloneDeep(this.userProfile);
            userNew.lang = this.userProfile.lang;
        }
        return this.userprofileService.postUserprofile(userNew).pipe(map(data => {
            console.log(data);
            return userNew;
        }),catchError((error: any) => {
            console.log(error);
            throw error;
        }));
    }

    /**
    * @description
    * Deshabilita o habilita el botón guardar
    */
    deshabilitar() {
        //Ambos objetos están definidos y no son nulos
        if (Utils.noUndfAndNull(this.originalUserProfile) && Utils.noUndfAndNull(this.userProfile)) {

            if(this.originalUserProfile.lang == null){
                if (Utils.noUndfAndNull(this.userProfile.lang)) {
                    return false;
                }else{
                    return true;
                }
            }else{
            if ((!Utils.compareTextOrNumber(this.originalUserProfile.lang, this.userProfile.lang)
            ) && (this.userProfile.lang !== ""))
                return false;
            }
        }
        //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
        else if ((Utils.noUndfAndNull(this.userProfile) && !Utils.noUndfAndNull(this.originalUserProfile)) || (!Utils.noUndfAndNull(this.userProfile) && Utils.noUndfAndNull(this.originalUserProfile))) {
            return false;
        }
        return true;

    }

    /**
    * @description
    * Deshabilita o habilita el botón aceptar
    */
    deshabilitarAceptar() {
        if (Utils.noUndfAndNull(this.userProfile.lang)) {
            return false;
        }else{
            return true;
        }
    }

    build() {
    }
}
